import { render } from 'benchpress';

export default render;
